import { render, staticRenderFns } from "./LimitedItem.vue?vue&type=template&id=1a282df0&scoped=true&"
import script from "./LimitedItem.vue?vue&type=script&lang=js&"
export * from "./LimitedItem.vue?vue&type=script&lang=js&"
import style0 from "./LimitedItem.vue?vue&type=style&index=0&id=1a282df0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a282df0",
  null
  
)

export default component.exports